// extracted by css-extract-rspack-plugin
export default {"track":"HQQqeHN9Ea8t7DcB","fill":"CR90wQbvNg0iRPoy"};